import React from 'react'
import { Customize, Bin, Edit } from '../../atoms/NewIcons'
import { DatatableRow, DatatableCell } from '../../atoms/Datatable/Datatable'
import Button from '../../atoms/Button/Button'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { Trans } from '../../atoms'
import { priceNotation } from '../../../utils/safe'
import useTrans from '../../../hooks/useTrans'
import { DataTableCreaOffertaCols } from '../DataTableRowCreaOfferta/DataTableRowCreaOfferta'
import _ from 'lodash'

const EditPersonalizzazioneButton = ({ id, codice, router, label }) => {
  return (
    <Link href={`/cart/personalizzazione/${id}/${codice}`}>
      <a>
        <Button
          label={label}
          variant="ghost"
          size="medium"
          icon={<Edit />}
          icon_pos="left"
          className="datatable-row-personalizzazione__edit-button"
        />
      </a>
    </Link>
  )
}

const DeletePersonalizzazioneButton = ({ id, codice, router, onDelete, label }) => {
  return (
    <Button
      label={label}
      variant="ghost"
      size="medium"
      colorVariant="black"
      icon={<Bin />}
      icon_pos="left"
      className="datatable-row-personalizzazione__delete-button"
      onClick={() => onDelete()}
    />
  )
}

const DatatableRowPersonalizzazione = ({
  id,
  prodotto,
  posizioni,
  codice,
  numero_colori,
  totale_personalizzazione,
  tecnica,
  onDelete,
  stesso_logo,
  posizione,
  prezzo_personalizzazione_unitario,
  quantita,
  creaOfferta,
  rigaId,
}) => {
  const router = useRouter()
  const t = useTrans()

  const cols = creaOfferta
    ? creaOfferta?.preview
      ? _.omit(DataTableCreaOffertaCols, [
          creaOfferta?.tipoMarkup === 'sul_totale' ? 'totale_quotazione' : '',
          'margine',
          creaOfferta?.preview
            ? 'prezzoPezzo'
            : creaOfferta?.tipoMarkup === 'sul_totale'
            ? 'prezzoPezzo'
            : '',
          creaOfferta?.preview
            ? 'totale'
            : creaOfferta?.tipoMarkup === 'sul_totale'
            ? 'totale'
            : '',
        ])
      : DataTableCreaOffertaCols
    : {
        prodotto: { label: t('Descrizione'), mobileCols: 12 },
        modifica: { label: '', width: '165px', mobileHidden: true },
        prezzoPezzo: { label: t('Prezzo/Pz'), width: '100px', mobileCols: 6 },
        spacer: { label: '', width: '100px', mobileHidden: true }, // Per allinearla alle righe del carrello che hanno la quantità
        totale: { label: t('Totale'), width: '100px', mobileCols: 6 },
        elimina: { label: '', width: '36px', mobileHidden: true },
        actionsMobile: { label: '', desktopHidden: true, mobileCols: 12 },
      }

  const getTecnica = (posizioni, tecnica) => {
    const tecniche = posizioni?.map((posizione) => posizione?.personalizzazione?.tecnica?.nome)
    return tecniche?.length > 1 ? tecniche?.join(' - ') : tecnica
  }

  const getPosizione = (posizioni, posizione) => {
    const pos = posizioni?.map((posizione) => posizione?.personalizzazione?.posizione?.nome)
    return pos?.length > 1 ? pos?.join(' - ') : posizione
  }

  const getNumeriColori = (posizioni, numero_colori) => {
    const n_colori = posizioni?.map(
      (posizione) => posizione?.personalizzazione?.numero_colori_descrizione
    )
    return n_colori?.length > 1 ? n_colori?.join(' - ') : numero_colori
  }

  return (
    <DatatableRow className="datatable-row-personalizzazione">
      <DatatableCell col={cols.prodotto}>
        <div className="personalizzazione-info">
          <div className="personalizzazione-info__icon">
            <Customize />
          </div>
          <div className="personalizzazione-info__content">
            <p className="personalizzazione-info__title">{getTecnica(posizioni, tecnica)}</p>
            <p>
              {posizioni && posizioni.length > 1 ? t('2 Posizioni') : t('1 Posizione')}{' '}
              {posizioni && posizioni.length > 1 && !stesso_logo && 'con loghi diversi'}
              {/* <Trans chiave="Info sulla personalizzazione" /> */}
            </p>
            <p style={{ wordBreak: 'break-word' }}>
              <Trans chiave="Posizione" />: {getPosizione(posizioni, posizione)}
            </p>
            <p>
              <Trans chiave="Numero Colori" />: {getNumeriColori(posizioni, numero_colori)}
            </p>
          </div>
        </div>
      </DatatableCell>
      <DatatableCell col={cols.prodotto}>
        <div className="personalizzazione-info">
          {posizioni?.map((posizione) => (
            <p>{posizione?.descrizione_posizione}</p>
          ))}
        </div>
      </DatatableCell>
      <DatatableCell col={cols.modifica}>
        <EditPersonalizzazioneButton
          id={id}
          prodotto={prodotto}
          router={router}
          codice={codice}
          label={t('Modifica')}
        />
      </DatatableCell>

      {creaOfferta?.tipoMarkup !== 'sul_totale' && (
        <>
          {creaOfferta?.preview ? (
            <DatatableCell col={cols.prezzoPezzo}>
              {creaOfferta?.preview?.(quantita, id) + ' €'}
            </DatatableCell>
          ) : (
            <DatatableCell col={cols.prezzoPezzo}>
              {prezzo_personalizzazione_unitario
                ? priceNotation(prezzo_personalizzazione_unitario, 3) + ' €'
                : null}
            </DatatableCell>
          )}
        </>
      )}

      <DatatableCell col={cols.spacer}>{quantita}</DatatableCell>

      {creaOfferta && (
        <DatatableCell
          col={cols.quantita}
          className="datatable-row-cart__bspaced-cell"
        ></DatatableCell>
      )}

      {creaOfferta?.tipoMarkup !== 'sul_totale' && (
        <DatatableCell col={cols.totale}>
          <b>{priceNotation(totale_personalizzazione, 3)} €</b>
        </DatatableCell>
      )}

      <DatatableCell col={cols.elimina}>
        <DeletePersonalizzazioneButton
          id={id}
          prodotto={prodotto}
          router={router}
          onDelete={onDelete}
          label={t('Elimina personalizzazione')}
        />
      </DatatableCell>
      <DatatableCell col={cols.actionsMobile}>
        <EditPersonalizzazioneButton
          id={id}
          prodotto={prodotto}
          router={router}
          codice={codice}
          label={t('Modifica')}
        />
        <DeletePersonalizzazioneButton
          id={id}
          prodotto={prodotto}
          router={router}
          onDelete={onDelete}
          label={t('Elimina personalizzazione')}
        />
      </DatatableCell>

      {/* Crea Offerta */}
      {creaOfferta && creaOfferta?.margineInput && (
        <>
          <DatatableCell col={cols.margine}>
            {
              <creaOfferta.margineInput
                codice={id}
                totale={totale_personalizzazione}
                rigaId={rigaId}
              />
            }
          </DatatableCell>
          {!creaOfferta?.preview && (
            <DatatableCell col={cols.totale_quotazione}>
              <b>{creaOfferta?.totaleQuotazione(id)}</b>
            </DatatableCell>
          )}
        </>
      )}

      {creaOfferta && creaOfferta?.preview && creaOfferta?.tipoMarkup === 'sul_singolo' && (
        <DatatableCell col={cols.totale_quotazione}>
          <b>{creaOfferta?.totaleQuotazione(id)}</b>
        </DatatableCell>
      )}
    </DatatableRow>
  )
}

export default DatatableRowPersonalizzazione
